export const ESG_MOVEMENT_DATA_DIR_URL = `${process.env.SHARED_ASSETS_BASE_URL}/gasstoragelevel`;

export const ESG_MOVEMENT_DATA_PATHS = {
  lastMonth: `${ESG_MOVEMENT_DATA_DIR_URL}/eSG-vormonat.txt`,
  currentMonth: `${ESG_MOVEMENT_DATA_DIR_URL}/eSG-vorlaeufig.txt`,
};
